export default class Log {
  static track(eventCategory, eventAction, eventLabel, outbound = false) {
    if (typeof ga === 'undefined') { // eslint-disable-line no-undef
      console.log('[LOG]', eventCategory, eventAction, eventLabel);
    } else if (outbound) {
      ga('send', { // eslint-disable-line no-undef
        hitType: 'event',
        eventCategory,
        eventAction,
        eventLabel,
        transport: 'beacon',
      });
    } else {
      ga('send', { // eslint-disable-line no-undef
        hitType: 'event',
        eventCategory,
        eventAction,
        eventLabel,
      });
    }
  }
}
